import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { contentAPI } from '../utils/api';
import { galleryImages as fallbackData } from '../utils/mockData';
import { X } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [galleryImages, setGalleryImages] = useState(fallbackData);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const data = await contentAPI.getGallery();
      if (data && data.length > 0) {
        setGalleryImages(data);
      }
    };
    fetchData();
  }, []);

  const handlePrivateEventsClick = () => {
    navigate('/private-events');
    window.scrollTo(0, 0);
  };

  return (
    <section id="gallery" className="py-24 bg-gradient-to-b from-white to-[#F5EBE0]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl mb-6"
            style={{ fontFamily: 'var(--font-serif)' }}
          >
            Experience Brick Lane
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto mb-4">
            Immerse yourself in our world where tradition meets innovation
          </p>
          <button 
            onClick={handlePrivateEventsClick}
            className="text-lg text-[#B8956A] font-medium hover:text-[#96794d] hover:underline transition-all"
          >
            Schedule your next event or book a catering →
          </button>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, idx) => (
            <div
              key={image.id || image.url || idx}
              className="relative group cursor-pointer overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
              onClick={() => setSelectedImage(image)}
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
            onClick={() => setSelectedImage(null)}
            aria-label="Close"
          >
            <X size={32} />
          </button>
          <div className="max-w-6xl max-h-[90vh]">
            <img
              src={selectedImage.url}
              alt={selectedImage.alt}
              className="max-w-full max-h-[85vh] object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
